// @flow
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { connect } from "../../../base/redux";
import { setDeviceContainerStatus, showMixerSettingsModal } from "../../redux/tool-webjam-v2/actions";
import { ct } from "../../constant-Utils";

const LightingButtonActions = (props) => {
    const dispatch = useDispatch()

    useEffect(() => {
    }, []);

    const handleClick = (value) => {
        dispatch(setDeviceContainerStatus(value, 'LightingButtonActions'))
    }

    return (
        <li className="list-group-item lighting-options">
            <div className="lighting-actions"
                onClick={() => handleClick("openmixer")}
            >
                {ct("rta-trmc.mixer.mixer")}
            </div>
            <div className="lighting-actions"
                onClick={() => dispatch(showMixerSettingsModal(true))}
            >
                {ct("rta-trmc.mixer.mixerSetting")}
            </div>
            <div className="lighting-actions"
                onClick={() => handleClick("unpair")}
            >
                {ct("rta-trmc.themeMessage.rta.boxUnPairTitle")}
            </div>
        </li>
    );
};

const mapStateToProps = (state) => {
    return {
    }
}

export default connect(mapStateToProps)(LightingButtonActions);

